interface CaseSensitiveToggleProps {
	active: boolean;
	onToggle: () => void;
	testId?: string;
}

/** 検索欄の中に置く「大文字と小文字を区別」トグル。 */
export function CaseSensitiveToggle({ active, onToggle, testId }: CaseSensitiveToggleProps) {
	return (
		<button
			type="button"
			onClick={onToggle}
			title="大文字と小文字を区別"
			data-active={active ? "true" : "false"}
			data-testid={testId}
			className={`shrink-0 cursor-pointer rounded-1 border-0 px-[3px] py-px font-mono text-caption ${
				active ? "bg-accent-subtle text-accent" : "bg-transparent text-fg-3"
			}`}
		>
			Aa
		</button>
	);
}
